import { createApp } from 'vue'
import BilesikFaiz from './BilesikFaiz.vue'
import './assets/global.css'

createApp(BilesikFaiz).mount('#bilesik-faiz')
